import { autoinject, bindable, bindingMode } from 'aurelia-framework';
import { containerless } from 'aurelia-templating';

/**
 * Render a loading spinner on an element.
 * The look and feel of the loader can be customised using the exposed properties.
 * <br>
 * The &lt;overlay-loader&gt; element should be placed at the bottom of the container where it should be rendered.
 * The loader element will be positioned absolutely and will occupy the full width and height of the container.
 * The look and feel may be customised further by styling relative to the target element.
 */
@autoinject
@containerless
export class OverlayLoader {
	/**
	 * Set as false to disable the overlay. True by default.
	 */
	@bindable({ defaultBindingMode: bindingMode.toView })
	public hasOverlay: boolean = true;

	/**
	 * Display an optional "loading" message along with the spinner.
	 * There is no message by default.
	 */
	@bindable({ defaultBindingMode: bindingMode.toView })
	public loadingMessage: string;

	/**
	 * Size of the spinner. The value may range from 1 to 10.
	 * The default value is 3.
	 */
	@bindable({ defaultBindingMode: bindingMode.toView })
	public loaderSize: number = 3;

	/**
	 * Specify a delay in ms after which the loader should appear.
	 * This is 100ms by default.
	 */
	@bindable({ defaultBindingMode: bindingMode.toView })
	public delayDuration: number = 100;

	/**
	 * Bind to this property to indicate whether the loader should be displayed.
	 */
	@bindable({ defaultBindingMode: bindingMode.toView })
	public isLoading: boolean = false;
}
